import { actualDefaultLocale, localesArr, rtlLocales } from './locales';

import { Direction } from '@mui/material';
import { ILocale } from './types';
import { setCookie } from 'cookies-next';

export const NEXT_LOCALE_COOKIE_KEY = 'NEXT_LOCALE';

export function setLocalCookie(locale: ILocale) {
  let newLocale = locale;
  if (!localesArr.includes(locale)) {
    newLocale = actualDefaultLocale;
  }
  setCookie(NEXT_LOCALE_COOKIE_KEY, newLocale, { expires: new Date('1/1/2030') });
}

/**
 * It returns the language from the user's storage, or the guest's storage, or the router's locale
 * @returns The current language.
 */
// export function getCurrentLang() {
//   if (!checkIsBrowser()) {
//     throw new Error("Don't use getCurrentLang during SSR");
//   }

//   return (
//     storage?.user?.get()?.language || storage?.guest?.get()?.language || router?.locale
//   );
// }

/**
 * It checks if the locale is RTL
 * @param {ILocale} locale - The locale to check.
 * @returns A function that takes in a locale and returns a boolean.
 */
export function checkIsRtl(locale: ILocale): boolean {
  return rtlLocales.includes(locale);
}

/**
 * It takes a locale string, checks if it's an RTL locale, and returns the direction
 * @param {string} locale - string
 * @returns A function that takes a locale and returns a direction.
 */
export function getDirection(locale: string): Direction {
  return checkIsRtl(locale as ILocale) ? 'rtl' : 'ltr';
}
